var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:_vm.wrapClass,attrs:{"to":_vm.profileLink(_vm.userId)}},[_c('Username',{attrs:{"username":_vm.username,"user-address":_vm.userAddress}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }